import rm_1 from "assets/images/compressed/Cootie (260).jpg"
import rm_2 from "assets/images/compressed/Cootie (1587).jpg"
import rm_3 from "assets/images/compressed/Cootie (1588).jpg"
import rm_4 from "assets/images/compressed/Cootie (2822).jpg"
import rm_5 from "assets/images/compressed/Cootie (2242).jpg"

const RoadMAP = () => {
    const dataArray = [
        {
            title: "Laying the Groundwork", 
            bodyText:
                <>
                    <li>Team formation</li>
                    <li>Conceptualization</li>
                    <li>Cootie design</li>
                </>
        },
        {
            title: "Starting of Ops",
             bodyText:
                <>
                    <li>Marketing strategies</li>
                    <li>Social media set-up</li>
                    <li>Discord creation</li>
                    <li>Telegram creation</li>
                    <li>Partnerships</li>
                </>
        },
        {
            title: "Whitelist Presale", 
            bodyText:
                <>
                    <li>500 whitelist Spots Marketplace Development</li>
                </>
        },
        {
            title: "Public Sale", 
            bodyText:
                <>
                    <li>4444 NFTs to mint on each blockchain</li>
                </>
        },
        {
            title: "Marketplace", 
            bodyText:
                <>
                    <li>We have built our own marketplace to view and sell your Cootie NFTs This makes our Non-Fungible Tokens stand out from all the others In our market place you will also be able to spend your CootieCoins on other NFTs and Real-life items including merch and special promotions</li>
                </>
        },
        {
            title: "Fractionalization", 
            bodyText:
                <>
                    <li>The Cootie Card Game Development</li>
                </>
        },
        {
            title: "Metaverse", 
            bodyText:
                <>
                    <li>Begin metaverse development</li>
                </>
        },
        {
            title: "Merch Drop", 
            bodyText:
                <>
                    <li>Release The Cootie merch</li>
                </>
        },
    ];
    return (
        <section id="roadmap" className="roadmap-main">
            <div className="container">
                <div className="sec-heading-wrapper">
                    <h1 data-aos="fade-down" className="sec-heading">Roadmap</h1>
                </div>
                <div className="rd-timeline">
                    <div className="timeline-left">
                        {dataArray.map((data, index) => {
                            return (
                                <div key={index} className="container-map">
                                    <div className="content" data-aos="fade-up">
                                        <h3 className="roadmap-section-heading">{data.title}</h3>
                                        <ul>
                                            {data.bodyText}
                                        </ul>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                    <div className="timeline-right">
                        <img loading="lazy" data-aos="fade-up" src={rm_1} alt="The Cootie" />
                        <img loading="lazy" data-aos="fade-up" src={rm_2} alt="The Cootie" />
                        <img loading="lazy" data-aos="fade-down" src={rm_3} alt="The Cootie" />
                        <img loading="lazy" data-aos="fade-down" src={rm_4} alt="The Cootie" />
                        {/* <img loading="lazy" data-aos="fade-down" src={rm_5} alt="The Cootie" /> */}
                    </div>
                </div>
            </div>
        </section>
    )
};





export default RoadMAP
